var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-container"},[_c('div',[(this.$store.getters.profile)?_c('profile-card'):_vm._e()],1),_c('div',[_c('change-password-card')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }